<template>
  <b-card>
    <div slot="header" class="font-weight-bold">Buscador de productos</div>

    <!-- Filtro -->
    <b-row>
      <b-col sm="12" md="3">
        <b-form-group>
          <div class="d-flex align-items-center justify-content-between">
            <label>Nombre</label>
            <span class="d-inline-flex align-items-center">
              <small class="mr-1 text-muted">¿Coincidencia exacta?</small>
              <b-form-checkbox v-model="filtro.exact_match" size="sm" />
            </span>
          </div>
          <b-form-input id="nombre" name="nombre" type="text" v-model="filtro.nombre"
            @keypress.enter="buscador(filtro)" />
        </b-form-group>
      </b-col>
      <b-col sm="12" md="3">
        <b-form-group>
          <label for="sinonimo">Sinonimo</label>
          <b-form-input id="sinonimo" name="sinonimo" type="text" v-model="filtro.sinonimos"
            @keypress.enter="buscador(filtro)" />
        </b-form-group>
      </b-col>
      <b-col sm="12" md="3">
        <b-form-group>
          <label for="">Fabricante</label>
          <el-select id="id_fabricante" name="id_fabricante" v-model="filtro.id_fabricante" filterable remote clearable
            multiple no-data-text="No hay datos que coincidan" no-match-text="No hay datos que coincidan"
            :remote-method="obtenerFabricantesFiltro" @change="buscador(filtro)">
            <el-option v-for="fabricante in fabricantes_filtro" :key="fabricante.id" :label="fabricante.nombre"
              :value="fabricante.id" />
          </el-select>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="3">
        <b-form-group>
          <label for="fecha">Fecha</label><br />
          <el-date-picker v-model="filtro.confecha" id="range_date" name="range_date" type="daterange"
            range-separator="a" value-format="yyyy-MM-dd" format="yyyy-MM-dd" start-placeholder="Fecha inicio"
            end-placeholder="Fecha fin" class="w-100" @change="buscador(filtro)">
          </el-date-picker>
        </b-form-group>
      </b-col>
      <b-col v-if="listarEmpresas" sm="12" md="3">
        <b-form-group>
          <label for="proveedor">Proveedor</label>
          <el-select id="proveedor" name="proveedor" v-model="filtro.proveedor" filterable remote clearable
            no-data-text="No hay datos que coincidan" no-match-text="No hay datos que coincidan"
            :remote-method="fetchProviders" @change="cambiarProveedor">
            <el-option v-for="proveedor in proveedores" :key="proveedor.id" :label="proveedor.name"
              :value="proveedor.id" />
          </el-select>
        </b-form-group>
      </b-col>
      <b-col v-if="listarEmpresas" sm="12" md="3">
        <b-form-group>
          <label for="">Empresa</label>
          <el-select id="empresa" name="empresa" v-model="filtro.empresa" @change="cambiarEmpresa(filtro.empresa)"
            filterable remote clearable no-data-text="No hay datos que coincidan"
            no-match-text="No hay datos que coincidan" :remote-method="obtenerEmpresasFiltro">
            <el-option v-for="empresa in empresas_filtro" :key="empresa.id" :label="empresa.nombre" :value="empresa.id">
            </el-option>
          </el-select>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="3" v-if="filtro.empresa && allCountries.length > 1">
        <b-form-group label="País" horizontal="">
          <el-select v-model="filtro.country_id" filterable clearable no-data-text="No hay datos que coincidan"
            :disabled="!filtro.empresa" no-match-text="No hay datos que coincidan">
            <template slot="prefix" v-if="selectedCountryCode">
              <div class="flag-prefix-container">
                <img :src="`https://flagsapi.com/${selectedCountryCode}/flat/64.png`" class="flag-img-select" @error="$event.target.style.display='none'" @load="$event.target.style.display=''">
              </div>
            </template>
            <el-option v-for="item in allCountries" :key="item.country.id" :label="item.country.name"
              :value="item.country.id">
              <div class="d-flex align-items-center">
                <img :src="`https://flagsapi.com/${item.country.code.toUpperCase()}/flat/64.png`"
                  class="mr-2 flag-img-option" @error="$event.target.style.display='none'" @load="$event.target.style.display=''">
                <span>{{ item.country.name }}</span>
              </div>
            </el-option>
          </el-select>
        </b-form-group>
      </b-col>
      <b-col v-if="filtro.empresa && validarPermisoComponente('filtrar-productos-asignados-pagos')" sm="12" md="3">
        <b-form-group>
          <label for="bases">Caracterizados y Asignaciones</label>
          <el-select v-model="filtro.product_status" clearable size="sm" class="form-contol">
            <el-option v-for="(productStatus, index) in productStatuses" :value="productStatus.value"
              :label="productStatus.label" :key="index" />
          </el-select>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="3" v-if="filtro.empresa && validarPermisoComponente('ver-filtro-uso-buscador-productos')">
        <b-form-group>
          <label for="bases">Disponible en el inventario</label>
          <el-select v-model="filtro.in_use" clearable size="sm" class="form-contol">
            <el-option v-for="(in_use, index) in inUse" :value="in_use.value" :label="in_use.label" :key="index" />
          </el-select>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="3" v-if="filtro.empresa">
        <b-form-group>
          <label for="bases">Ubicaciones</label>
          <treeselect placeholder="Buscar..." :options="treeWithChildrens" v-model="val" :searchable="true"
            :show-count="true" :multiple="true" :defaultExpandLevel="Infinity" @input="filtrarUbicaciones"
            value-consists-of="ALL" :normalizer="normalizer">
            <template slot="option-label" slot-scope="{ node }">
              <div class="d-flex align-items-center">
                <span>{{ node.label }}</span>
                <!-- Contador de hijos (siempre se mostraba cuando show-count="true" antes de sobreescribir el slot) -->
                <span v-if="node.children && node.children.length > 0" class="text-muted ml-1">
                  ({{ node.children.length }})
                </span>
                <!-- País asignado directamente en el nodo -->
                <span v-if="node.raw.company_country && node.raw.company_country.country" class="ml-2">
                  <img :src="`https://flagsapi.com/${node.raw.company_country.country.code.toUpperCase()}/flat/64.png`"
                    class="flag-img-tree" @error="$event.target.style.display='none'" @load="$event.target.style.display=''">
                </span>
              </div>
            </template>
          </treeselect>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="3" v-if="camposActivosFiltrados.length > 0 && filtro.empresa">
        <b-form-group>
          <label for="campos">Campos Personalizados</label>
          <el-select v-model="filtro.campoPersonalizado" clearable filterable remote
            no-data-text="No hay datos que coincidan" no-match-text="No hay datos que coincidan"
            @focus="getCamposPersonalizadosProd()" @change="buscador(filtro)">
            <el-option v-for="item in camposActivosFiltrados" :key="item.id" :label="item.nombre" :value="item.id" />
          </el-select>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="3" v-if="camposActivosFiltrados.length > 0 && filtro.empresa">
        <b-form-group>
          <label for="valorcampo">Valor</label>
          <b-form-input class="el-input__inner" id="valorcampo" name="valorcampo" type="text"
            v-model="filtro.valorcampo" @keypress.enter="buscador(filtro)" />
        </b-form-group>
      </b-col>

      <b-col sm="12" md="3" v-if="!editarProductos">
        <b-form-group>
          <label for="valorcampo">Estado del producto</label>
          <el-select v-model="filtro.product_status_company" clearable class="form-contol">
            <el-option v-for="(in_use, index) in product_statuses" :value="in_use.value" :label="in_use.label"
              :key="index" />
          </el-select>
        </b-form-group>
      </b-col>

      <b-col sm="12" md="3" v-if="validarPermisoComponente('filtro-estado-buscador-producto')">
        <label for="bases">Estado</label>
        <el-select v-model="filtro.estado" size="sm" class="form-contol">
          <el-option v-for="estado in status" :value="estado.text" :label="estado.text" :key="estado.id"
            :style="'background:' + estado.color + '; color: black;'" />
        </el-select>
      </b-col>
      <b-col sm="12" md="3" v-if="validarPermisoComponente('filtro-productos-componente')">
        <b-form-group>
          <label for="component">Componentes</label>
          <el-select id="component" name="component" v-model="filtro.component" placeholder="Por nombre o numero de cas"
            filterable remote clearable no-data-text="No hay datos que coincidan"
            no-match-text="No hay datos que coincidan" :remote-method="searchComponentRemote">
            <el-option v-for="component in todosLoscomponentes.data" :key="component.id" :label="component.name"
              :value="component.id">
            </el-option>
          </el-select>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="3" v-if="validarPermisoComponente('filtro-productos-cas')">
        <b-form-group>
          <label for="component">CAS del producto</label>
          <b-form-input class="el-input__inner" id="nombre" name="nombre" type="text" v-model="filtro.cas" />
        </b-form-group>
      </b-col>
      <b-col v-if="showAttachmentTypeSelect" sm="12" md="3">
        <b-form-group>
          <label for="tipo">Tipo de adjunto</label>
          <el-select v-model="filtro.tipo" clearable :rows="3" :max-rows="6" name="type" id="type">
            <el-option v-for="language in filteredAvailableTypes" :key="language.value" :label="language.text"
              :value="language.value">
            </el-option>
          </el-select>
        </b-form-group>
      </b-col>

      <b-col
        v-if="filtro.empresa && [154, ''].includes(filtro.tipo) && validarPermisoComponente('filtro-tipos-adjuntos')"
        sm="12" md="3">

        <b-form-group>
          <label for="tipo">Cumplimiento adjuntos</label>
          <el-select @change="resetTipeDoc($event)" v-model="filtro.cumplimiento" clearable :rows="3" :max-rows="6"
            name="type" id="type">
            <el-option v-for="item in filteredAttachmentComplianceList" :key="item.id" :label="item.lista"
              :value="item.id">
            </el-option>
          </el-select>
        </b-form-group>
      </b-col>

      <b-col sm="12" md="3" v-if="filtro.empresa && usuarioAdmin">
        <b-form-group>
          <label for="comments">Comentario</label>
          <b-form-input id="comments" class="el-input__inner" name="comments" type="text"
            v-model.trim="filtro.comments" />
        </b-form-group>
      </b-col>

      <b-col sm="12" md="2" v-if="validarPermisoComponente('ver-productos-sin-empresas-relacionadas')">
        <b-form-group>
          <label for="comments">Productos sin empresas</label>
          <b-form-checkbox v-model="filtro.product_without_company" name="product_without_company" switch size="lg">
          </b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col v-if="filtro.empresa && esAdmin" sm="12" md="2">
        <b-form-group>
          <label for="bases">Bloqueados</label>
          <b-form-checkbox v-model="filtro.bloqueado" name="bloqueado" switch size="lg" @change="buscador(filtro)">
          </b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col v-if="filtro.empresa && validarPermisoComponente('ver-productos-sin-ubicaciones')" sm="12" md="2">
        <b-form-group>
          <label for="bases">Sin Ubicaciones</label>
          <b-form-checkbox v-model="filtro.without_location" name="without_location" switch size="lg"
            @change="buscador(filtro)">
          </b-form-checkbox>
        </b-form-group>
      </b-col>



    </b-row>

    <!-- Filtro adicional solo productos temporales -->
    <b-row>
      <b-col v-if="validarPermisoComponente('filtrar-productos-temporales')" class="my-3">
        <b-form-checkbox v-model="filtro.temporales" @change="buscador(filtro)" class="pull-left">
          Solo productos temporales
        </b-form-checkbox>
      </b-col>
    </b-row>

    <!-- Botones de acciones del filtro -->
    <b-row>
      <b-col lg="4">
        <b-button variant="primary" @click.prevent="buscador(filtro)">
          <i class="fa fa-search fa-lg"></i>
          <span class="d-none d-md-inline-block">Buscar</span>
        </b-button>
        <b-button @click.prevent="limpiar(1)" class="ml-2">
          <i class="fa fa-eraser fa-lg"></i>
          <span class="d-none d-md-inline-block"> Limpiar</span>
        </b-button>
      </b-col>
      <b-col lg="2" style="margin-top: 10px"> </b-col>
      <b-col lg="6">
        <b-row align-h="end">
          <b-col v-if="filtro.empresa && upFileToUpdateProducts" lg="4" md="4" sm="12"
            class="d-flex justify-content-end">
            <b-dropdown id="dropdown-left" variant="primary">
              <template #button-content>
                <i class="fa fa-file-excel-o mr-2"></i> Procesar inventario
              </template>
              <b-dropdown-item href="#" @click="() => onHandleUpFileToUpdateProducts('UPDATE')"><i
                  class="fa fa-edit mr-2"></i>
                Actualización de productos</b-dropdown-item>
              <b-dropdown-item href="#" @click="() => onHandleUpFileToUpdateProducts('CREATE')"><i
                  class="fa fa-save mr-2"></i>
                Creación de productos</b-dropdown-item>
            </b-dropdown>
          </b-col>
          <b-col lg="3" md="4" sm="12">
            <b-button v-if="validarPermisoComponente('eliminar-multiples-productos-quimicos')"
              @click="deleteSelectedProducts()" variant="danger" class="btn-block">
              <i class="fa fa-trash"></i> Eliminar
            </b-button>
          </b-col>
          <b-col lg="3" md="4" sm="12">

            <!-- Botones de acciones de nuevo producto -->
            <b-button-group>

              <!-- Nuevo producto con IA -->
              <b-button v-b-tooltip.hover title="Crear producto con Inteligencia Artificial"
                v-if="usuarioAdmin && opcionGuardar && crearProductos && validarPermisoComponente('crear-productos-con-IA')"
                variant="primary" @click="openAiDrawer('CREATE')">
                <i class="fa fa-magic"></i> Crear con IA
              </b-button>

            </b-button-group>

          </b-col>
          <b-col lg="3" md="4" sm="12" align-h="end" v-if="addProductCompany">
            <b-button variant="primary" @click="openModalAssingProduct()">
              <i class="fa fa-plus text-white fa-lg mr-1" /> Asignar productos
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- historial -->
    <b-row class="mt-3">
      <b-col>

        <!-- Tabla productos -->
        <b-table class="b-table-asigns-m height-table-pr" style="font-size: 10pt;" responsive striped hover
          :items="getProductsData" :fields="filteredFields" :tbody-tr-class="unClass" thead-tr-class="table-active">

          <template v-slot:cell(select-product)="data">
            <b-form-checkbox v-if="validarPermisoComponente('eliminar-multiples-productos-quimicos')" class="pull-left"
              :value="data.item.id" v-model="selectedProductIds" @change="updateSelecteProducts(data.item)">
            </b-form-checkbox>
          </template>
          <template v-slot:cell(nombre)="data">
            {{ data.item.nombre }}
            <el-tooltip v-if="showCharacterized(data.item)" effect="dark" class="item" placement="top-start">
              <div slot="content">
                <span>Sin caracterizar</span>
              </div>
              <b-badge variant="warning">
                <i class="fa fa-exclamation"></i>
              </b-badge>
            </el-tooltip>

            <!-- Identificación de USO/DESUSO -->
            <div v-if="validarPermisoComponente('ver-badge-usos-en-tabla-productos') && filtro.empresa">
              <h5>
                <template v-if="isStatusUseByProduct(data.item)">
                  <b-badge v-if="getStatusUseByProduct(data.item)" variant="primary">
                    Disponible en el inventario
                  </b-badge>
                  <b-badge v-else variant="secondary">
                    No disponible en el inventario
                  </b-badge>
                </template>
                <b-badge v-else variant="secondary">
                  No disponible en el inventario
                </b-badge>
              </h5>
            </div>

            <el-tooltip v-if="validarAsignacionProductoContratista(data.item).length" class="item" effect="dark"
              placement="top-start">
              <div slot="content">
                <span>PRODUCTO ASIGNADO POR:</span>
                <ul class="pt-2">
                  <li v-for="item in validarAsignacionProductoContratista(
                    data.item
                  )" :key="item">
                    {{ item.nombre }}
                  </li>
                </ul>
              </div>
              <span class="text-success font-weight-bold ml-1">*</span>
            </el-tooltip>
            <el-tooltip v-if="validarEdicionProductoContratista(data.item.id).length" class="item" effect="dark"
              placement="top-start">
              <div slot="content">
                <span>PRODUCTO MODIFICADO POR:</span>
                <ul class="pt-2">
                  <li v-for="item in validarEdicionProductoContratista(
                    data.item.id
                  )" :key="item">
                    {{ item.usuario.info_empresa.nombre }}
                  </li>
                </ul>
              </div>
              <span class="text-danger font-weight-bold ml-1">*</span>
            </el-tooltip>
          </template>
          <template v-slot:cell(modulo_creacion)="data">
            <span>{{ (data.item.modulo_creacion === 'productos') ? 'PRODUCTOS' : ((data.item.modulo_creacion ===
              'accidentes-mayores') ? 'ACCIDENTES MAYORES' : 'ANAISIS DE RIESGOS') }}</span>
          </template>
          <template v-slot:cell(sgaData)="data">
            <span v-if="data.item.sga.length > 0">SI</span>
            <span v-else>NO</span>
          </template>
          <template v-slot:cell(nfpaData)="data">
            <span v-if="data.item.nfpa != null">SI</span>
            <span v-else>NO</span>
          </template>
          <template v-slot:cell(unData)="data">
            <span v-if="data.item.u_n">SI</span>
            <span v-else>NO</span>
          </template>

          <template v-slot:cell(fecha)="data">
            <template v-for="adjunto in getAttachments(data.item.adjuntos)">
              <el-tooltip v-if="!validarPermisoComponente('no-descargar-adjuntos-productos')"
                :key="'tooltip-' + adjunto.id" effect="dark" placement="top"
                :content="`Descargar ${getType(adjunto)}${getLanguage(adjunto)}`" popper-class="py-1 px-2">
                <b-button :key="'btn-' + adjunto.id" size="sm" class="buttonAdjunto mb-1"
                  @click="descargaAdjunto(adjunto, data.item)">
                  <div v-if="isCluingTypeAttachment(adjunto) && adjunto.tipo_adjunto.codigo == 'CNP'">
                    <span>Cert, no Pelig</span>
                  </div>
                  <div v-else>
                    <span v-if="adjunto.fecha">
                      {{ adjunto.fecha }}
                    </span>
                    <span v-else> Sin fecha </span>
                  </div>
                </b-button>
              </el-tooltip>
              <b-button v-else :key="'btn-disabled-' + adjunto.id" size="sm" class="buttonAdjunto mb-1"
                :disabled="true">
                <div v-if="isCluingTypeAttachment(adjunto) && adjunto.tipo_adjunto.codigo == 'CNP'">
                  <span>Cert, no Pelig</span>
                </div>
                <div v-else>
                  <span v-if="adjunto.fecha">
                    {{ adjunto.fecha }}
                  </span>
                  <span v-else> Sin fecha </span>
                </div>
              </b-button>
            </template>
          </template>

          <template v-slot:cell(comments)="data">
            {{ showComment(data.item) }}
            <b-button @click="onHandleShowModalComments(data.item)" variant="link">Ver más</b-button>
          </template>


          <template v-slot:cell(actions)="data">

            <b-dropdown variant="primary" id="dropdown-1" text="Opciones" class="m-md-2" boundary="viewport" right>

              <template #button-content>
                <i class="fa fa-list-ul text-white fa-lg mr-1" />
              </template>


              <b-dropdown-item size="sm" :to="`/productos/${data.item.id}`">
                <i class="fa fa-eye text-info fa-lg mr-1" /> Ver
              </b-dropdown-item>

              <b-dropdown-item @click="eliminar(data.item)" v-if="eliminarProductos">
                <i class="fa fa-trash fa-lg text-danger mr-1 cursor-pointer" />
                Eliminar
              </b-dropdown-item>

              <b-dropdown-item v-if="bloquearProductos && !!data.item.producto_bloqueo" size="sm" v-b-modal.modal-lg>
                <el-tooltip effect="dark" placement="top" popper-class="py-1 px-2"
                  v-if="!data.item.producto_bloqueo.bloqueo">
                  <div slot="content">
                    <div>
                      <span class="font-weight-bold">Producto desbloqueado por:</span>
                      {{ data.item.producto_bloqueo.usuario_creacion.name }}
                    </div>
                    <div>
                      <span class="font-weight-bold">Fecha:</span> {{ data.item.producto_bloqueo.created_at }}
                    </div>
                    <div>
                      <span class="font-weight-bold">Motivo:</span>
                      {{
                        !!data.item.producto_bloqueo.motivo
                          ? data.item.producto_bloqueo.motivo
                          : data.item.producto_bloqueo.motivo_desbloqueo
                            ? data.item.producto_bloqueo.motivo_desbloqueo.lista
                            : ''
                      }}
                    </div>
                  </div>
                  <span @click="bloquearProducto(data.item.id)" style="cursor:pointer;">
                    <i class="fa fa-lock fa-lg text-success mr-1" />
                    Bloquear
                  </span>
                </el-tooltip>

                <el-tooltip effect="dark" placement="top" popper-class="py-1 px-2" v-else>
                  <div slot="content">
                    <div>
                      <span class="font-weight-bold">Producto bloqueado por:</span>
                      {{ data.item.producto_bloqueo.usuario_creacion.name }}
                    </div>
                    <div>
                      <span class="font-weight-bold">Fecha:</span> {{ data.item.producto_bloqueo.created_at }}
                    </div>
                  </div>
                  <span @click="obtenerMotivos(data.item.id)" style="cursor:pointer;">
                    <i class="fa fa-unlock-alt fa-lg text-warning mr-1" />
                    Desbloquear
                  </span>
                </el-tooltip>
              </b-dropdown-item>

              <b-dropdown-item @click="bloquearProducto(data.item.id)"
                v-if="bloquearProductos && isUncharacterizedProduct(data.item)">
                <i class="fa fa-lock fa-lg text-info mr-1" />
                Bloquear
              </b-dropdown-item>

              <b-dropdown-item v-if="verTE" :to="`/tarjeta-emergencia/${data.item.id}`">
                <i class="fa fa-address-card-o fa-lg text-black-50 mr-1" />
                Tarjeta de Emergencia
              </b-dropdown-item>

              <b-dropdown-item v-if="asignarProductos && validarPermisoComponente('autogestionar-producto-empresa')"
                size="sm" @click="asigProducto(data.item)" v-b-modal.modal-lg>
                <i class="fa fa-list-alt fa-lg mr-1" />
                Asignación
              </b-dropdown-item>

              <!-- Actualizar producto con IA -->
              <b-dropdown-item v-if="validarPermisoComponente('actualizar-productos-con-IA')"
                @click="openAiDrawer('UPDATE', data.item.id)">
                <i class="fa fa-magic text-info fa-lg mr-1" />
                Actualizar producto con IA
              </b-dropdown-item>

              <b-dropdown-item v-if="validarPermisoComponente('duplicar-productos')"
                @click="showModalDuplicPr(data.item)">
                <i class="fa fa-copy text-info fa-lg mr-1 clickeable" />
                Duplicar producto
              </b-dropdown-item>

              <b-dropdown-item v-if="validarPermisoComponente('modulo-productos-listado-puede-ver-adjuntos')"
                @click="onHandleShowModalAttachments(data.item)">
                <i class="fa fa-file-text-o text-info fa-lg mr-1 clickeable" />
                Ver Adjunto
              </b-dropdown-item>

            </b-dropdown>

          </template>
        </b-table>

        <!-- No hay resultados para mostrar. -->
        <div v-if="!getProductsData || getProductsData.length <= 0"
          class="d-flex justify-content-center w-full w-100 p-2">
          <span>No hay resultados para mostrar.</span>
        </div>

        <!-- Paginar tabla -->
        <el-pagination class="float-right" v-model="filtro.page" @size-change="setPerPagePagination"
          @current-change="setPagePagination" :current-page="filtro.page" :page-sizes="[10, 30, 50, 100]"
          :page-size="filtro.perPage" layout="total,sizes, prev, pager, next" :total="productos.total" />

      </b-col>
    </b-row>

    <!-- modales, helpers -->
    <b-modal hide-footer v-model="modalAsignacion.ver" size="lg">
      <template #modal-title>
        <div class="d-flex flex-column align-items-star">
          <span>{{ infoProducto.nombre }}</span>
          <b-form-checkbox v-model="infoProducto.in_use" class="mt-2" @change="openModalToChangeUse(infoProducto)">
            Disponible en inventario
          </b-form-checkbox>
        </div>
      </template>
      <TabsAsignacion v-if="modalAsignacion.ver" :IdProducto.sync="IdProducto" />
    </b-modal>

    <b-modal hide-footer v-model="modalSearchAndAssingProducts.show" size="lg" :title="companyName">
      <SearchAndAssignProducts v-if="modalSearchAndAssingProducts.show" />
    </b-modal>

    <paso-a-paso />

    <!-- Modal para desbloqueo de producto -->
    <modal-desbloqueo @desbloqueado="buscador(filtro)" />

    <!-- Modal duplicar producto -->
    <b-modal v-model="modalDuplPr" id="modal_dupl_product" hide-footer title="Formulario duplicar producto" size="lg">
      <ModalDuplicProduct :product="currentProduct" />
    </b-modal>

    <!-- Modal detalles -->
    <modalDetailsTraceablePQHistoryComponent :canCreateNotes="true" />

    <!-- Contenido para mostrar y controlar la subida de actualizaciones de productos por medio de archivos excel -->
    <UpFromFileContentView />

    <!-- Modal eliminar producto -->
    <ModalDeleteProduct :product="productDelete" :show_modal="showModalDelete" @close="showModalDelete = false" />

    <!-- fragmentos -->
    <modalTraceablePQComponentInHistory ref="modalTraceablePQComponentRef" :confirmAssigned="confirmActionTraceablePQ"
      :loading="loading" />

    <ModalVisualizerAttachment v-if="productModalVisualizerAttachment" :data="productModalVisualizerAttachment"
      ref="refModalVisualizerAttachment" />

    <!-- Modal IA para crear producto -->
    <ProductAiDrawer ref="aiDrawerCreate" :action="'CREATE'" :opcionGuardar="opcionGuardar"
      :crearProductos="crearProductos" @open-manual-creation-modal="openModalToCreateProduct" />

    <!-- Modal IA para actualizar producto -->
    <ProductAiDrawer ref="aiDrawerUpdate" :action="'UPDATE'"
      @update-temporary-product-with-ia="onHandleUpdateTemporaryProductWithIA" />

  </b-card>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";

import loader from '../../containers/loader';
import TabsAsignacion from '../productos/asignacion/Tabs';
import SearchAndAssignProducts from '../productos/asignacion/SearchAndAssignProducts'
import pasoAPaso from './pasoapaso/modal';
import { getAcls, obtenerRol, validarPermisoComponente, validarRol } from '../../plugins/acl';
import useCompanyCountries from '../../composables/country/useCompanyCountries'
import useCompanyLocationsTree from '../../composables/location/useCompanyLocationsTree'
import modalDesbloqueo from './modal_desbloqueo';
import Treeselect from '@riophae/vue-treeselect';
import Swal from 'sweetalert2';
import ModalDuplicProduct from './ModalDuplicProduct';
import modalDetailsTraceablePQHistoryComponent from './../history/assignPQ/fragments/ModalTraceablePQHistory.vue'
import UpFromFileContentView from './upFromFile/ContentView.vue'
import ModalDeleteProduct from './ModalDeleteProduct.vue'
import modalTraceablePQComponentInHistory from './asignacion/fragments/ModalTraceablePQ.vue'
import ModalVisualizerAttachment from './adjuntos/fragments/ModalVisualizerAttachment.vue'

// Componentes IA
import ProductAiDrawer from './ia/ProductAiDrawer.vue';

export default {
  name: 'buscador-productos',
  mixins: [useCompanyCountries, useCompanyLocationsTree],
  components: {
    TabsAsignacion,
    SearchAndAssignProducts,
    loader,
    Treeselect,
    pasoAPaso,
    modalDesbloqueo,
    ModalDuplicProduct,
    modalDetailsTraceablePQHistoryComponent,
    UpFromFileContentView,
    ModalDeleteProduct,
    modalTraceablePQComponentInHistory,
    ModalVisualizerAttachment,
    ProductAiDrawer
  },

  data() {
    return {
      removeFilterByBtnTrash: false,
      firstLoad: true,
      editarProductos: false,
      crearProductos: false,
      upFileToUpdateProducts: false,
      verTE: false,
      bloquearProductos: false,
      asignarProductos: false,
      eliminarProductos: false,
      listarEmpresas: false,
      acls: '',
      companyName: null,
      verProductos: false,
      cargandoUbicaciones: false,
      mostrar: false,
      columnas: [],
      rangeYear: ['', ''],
      IdProducto: null,
      listaEmpresas: [],
      listaFabricantes: [],
      infoModal: {
        id: 'info-modal',
      },
      bloqueoboton: false,
      val: null,
      reset: false,
      disableAutoSelectLocations: false,
      status: [
        {
          id: 1,
          text: 'Aprobados',
          color: '#cdedd8'
        },
        {
          id: 2,
          text: 'En actualización',
          color: '#feeeba'
        },
        {
          id: 3,
          text: 'Incompletos',
          color: '#fcd6d6'
        },
        {
          id: 4,
          text: 'Por revisar',
          color: '#ffff'
        }
      ],
      product_statuses: [
        {
          value: 'characterized',
          label: 'Caracterizados'
        },
        {
          value: 'uncharacterized',
          label: 'Sin caracterizar'
        }
      ],
      validarPermisoComponente: validarPermisoComponente,
      inUse: [
        {
          value: null,
          label: ''
        },
        {
          value: 1,
          label: 'SI'
        },
        {
          value: 0,
          label: 'NO'
        }
      ],
      productStatuses: [
        {
          value: 'assigned',
          label: 'Asignados'
        },
        {
          value: 'unassigned',
          label: 'Sin Asignar'
        },
        {
          value: 'paid',
          label: 'Caracterizados'
        },
        {
          value: 'unpaid',
          label: 'Sin caracterizar'
        }
      ],
      currentProduct: null,
      modalDuplPr: false,
      searchTerm: '',
      optionsStatus: [
        {
          value: 'pagos',
          label: 'Pagos',
          color: '#bae6c9'
        },
        {
          value: 'cumple-documentos',
          label: 'Documentos con cumplimiento',
          color: '#FFCC80'
        },
        {
          value: 'documentos-no-cumplen',
          label: 'Documentos que no cumplen',
          color: '#ffeeba'
        },
        {
          value: 'sin-documentos',
          label: 'Sin documentos',
          color: '#fdd6d6'
        }
      ],
      selectedProductIds: [],
      showModalDelete: false,
      productDelete: {},
      productModalVisualizerAttachment: null
    };
  },
  beforeRouteLeave: function (to, from, next) {
    if (!to.path.includes('productos') && !to.path.includes('tarjeta-emergencia')) {
      this.reset = true;
    } else {
      this.reset = false;
    }
    next();
  },
  beforeDestroy() {
    if (this.reset) {
      this.resetFiltro();
      this.resetProductos();
      this.setUpFileExcelShow(false);
    }
  },
  async created() {
    this.load(true);
    this.setAddProductCompany(false);
    this.setAvailableQuantity(0);
    var acls = getAcls();
    var rol = acls.roles.toString();
    await this.getTipo();

    this.validarPermisos();
    if (this.usuarioAdmin) {
      this.cambiaPermisoGuardar(true);
    }

    if (this.usuarioEmpresaContratista) {
      this.setEsEmpresaContratista(true);
      this.cambiaPermisoGuardar(true);
    }

    this.asignaRolProductos(rol);
    this.asignaRol(rol);
    if (this.editarProductos) {
      await this.vistaAdmin();
    } else {
      this.setFiltro({ ...this.filtro, in_use: 1 });
      await this.vistaEmpresa();
      this.limpiaBasesAreasEmpresa();
    }
    this.load(false);
  },
  mounted() {
    this.$store.watch(
      () => {
        return this.getParams.filter_date;
      },
      (p) => {
        if (p == null) {
          this.getProductos();
          this.getEmpresasFil();
        }
      }
    );
    this.firstLoad = false;
  },
  methods: {

    ...mapMutations('etiquetas', {
      setAttachmentPdfProduct: 'etiquetaLink'
    }),

    /**
     * Abre el modal para agregar información sobre porque se realiza la acción (uso/no-uso).
     *
     * @param {*} item
     * @author Fernando Claros
     */
    openModalToChangeUse(producto) {
      this.cancelLoadings();
      this.setActionToTraceablePQ({
        action: 'USE',
        data: producto
      })
      this.$bvModal.show('modalTraceablePQComponent')
    },

    cancelLoadings() {
      this.setLoadingCancelProcess(false);
    },
    /**
   * Se confirma la acción desde el modal y se procesa la acción necesaria.
   *
   * @param Boolean isSuccess
   * @param Object payload
   * @param String|null comments
   * @author Fernando Claros
   */
    async confirmActionTraceablePQ(isSuccess, payload) {
      if (!isSuccess) {
        await this.getInfoAsignacion(this.IdProducto);
        await this.getEmpresasAsig(this.IdProducto);

        this.$bvModal.hide('modalTraceablePQComponent');
        this.cancelLoadings();

        return false;
      }

      if (payload.action === 'USE') {
        this.onHandleChangeUse({ ...payload.data, comments: this.traceable.comments, type: this.traceable.type });
        return false;
      }

      this.onHandleAssigned({ ...payload.data, comments: this.traceable.comments, type: this.traceable.type });
    },
    /**
      * Asignar/Desasignar.
      *
      * @param {*} data
      * @author Fernando Claros
      */
    async onHandleAssigned(data) {
      await this.validaAsignacion(data);
      this.$bvModal.hide('modalTraceablePQComponent')
      await this.getEmpresasAsig(this.IdProducto);
    },
    /**
   * Usar/No usar.
   *
   * @param {*} data
   * @author Fernando Claros
   */
    async onHandleChangeUse(item) {
      const payload = {
        product_id: this.IdProducto,
        in_use: item.in_use,
        company_id: this.filtro.empresa,
        comments: item.comments,
        type: item.type
      };
      await this.changeUseProductCompany(payload);
      this.$bvModal.hide('modalTraceablePQComponent')
      await this.getEmpresasAsig(this.IdProducto);
    },
    async onHandleUpFileToUpdateProducts(action) {
      this.resetHistoryRegistersProducts()
      this.setUpFileExcelShow({
        show: true,
        action
      });
      await this.getHistoryUpdateProducts({ current_page: 1, per_page: 10, company_id: this.filtro.empresa, action })
    },
    resetTipeDoc(val) {
      if (val == 'sd') {
        this.filtro.tipo = '';
      }
    },
    async isValidAddProductCompany() {
      const acls = getAcls();
      await this.validateAddProductCompany(acls.empresa);
      this.companyName = `${acls.info_empresa.nombre} - Cantidad disponible:${this.availableQuantity}`;
      this.setSelectedEmpresa(acls.info_empresa);
    },
    /**
     * Abrir modal para crear productos.
     * @author Fernando Claros
     */
    openModalToCreateProduct() {
      this.setComponents([]);
      this.setModalVer(true)
    },
    /**
     * Filtrar los adjuntos según las reglas de negocio.
     * Si tiene FDS entonces no se muestra el certificado: CNP
     * Si no tiene FDS entonces si se muestra el certificado: CNP
     * @author Fernando Claros
     */
    getAttachments(attachments) {

      // Solo devolveríamos FDS
      if (attachments.some(attachment => attachment.tipo == 154)) {
        return attachments.filter(attachment => {

          if (this.isCluingTypeAttachment(attachment)) return attachment.tipo_adjunto.codigo != "CNP"

          return attachment;
        });
      }

      // De lo contrario solo los adjuntos del producto sin excepciones
      return attachments;

    },
    /**
     * Validar si el adjunto trae su tipo.
     * @author Fernando Claros
     */
    isCluingTypeAttachment(attachment) {
      return 'tipo_adjunto' in attachment && attachment.tipo_adjunto != null ? true : false
    },
    showCharacterized(item) {
      if (item['is_characterized'] !== undefined && !item['is_characterized']) return true;
      else return false;
    },
    showModalDuplicPr(item) {
      this.currentProduct = item;
      this.modalDuplPr = true;
    },

    onHandleShowModalAttachments(item) {

      this.setAttachmentPdfProduct(item);
      this.productModalVisualizerAttachment = {
        product: item,
        attachment: item.adjuntos && typeof item.adjuntos === 'object' && item.adjuntos.length > 0 ? item.adjuntos[item.adjuntos.length - 1] : [],
        isReady: false
      }

      // Abrir modal
      this.$nextTick(() => {
        if (this.$refs.refModalVisualizerAttachment && this.$refs.refModalVisualizerAttachment.isModalReady()) {
          this.$refs.refModalVisualizerAttachment.showModal()
        } else {
          setTimeout(() => {
            if (this.$refs.refModalVisualizerAttachment) {
              this.$refs.refModalVisualizerAttachment.showModal()
            }
          }, 100)
        }
      })
    },

    onHandleCloseModalVisualizerAttachment() {
      this.$refs.refModalVisualizerAttachment.hideModal()
      this.productModalVisualizerAttachment = null;
    },

    normalizer(node) {
      return {
        id: node.id,
        label: node.label,
        children: Array.isArray(node.children) && node.children.length ? node.children : undefined,
        raw: node,
      };
    },
    validarPermisos() {
      this.asignarProductos = validarPermisoComponente('asignacion-basica-productos');
      this.bloquearProductos = validarPermisoComponente('bloquear-desbloquear-productos');
      this.verTE = validarPermisoComponente('administracion-tarjetas-emergencia-producto');
      this.editarProductos = validarPermisoComponente('editar-productos');
      this.crearProductos = validarPermisoComponente('crear-productos');
      this.upFileToUpdateProducts = validarPermisoComponente('cargar-excel-actualización-productos');
      this.eliminarProductos = validarPermisoComponente('eliminar-productos-quimicos');
      this.listarEmpresas = validarPermisoComponente('listar-empresas-asignadas');
      this.isValidAddProductCompany()
    },
    async limpiar() {
      this.removeFilterByBtnTrash = true;
      // Encender loading
      this.load(true);

      // Ajustar filtros
      this.mostrar = false;
      this.resetLocations();
      this.resetProductos();
      this.resetFiltro();
      // Evitar autoselección luego de limpiar
      this.disableAutoSelectLocations = true;

      if (this.editarProductos) await this.vistaAdmin();
      else {
        // Ubicaciones
        await this.cargarUbicaciones(this.acls.empresa);
        await this.vistaEmpresa();
      }

      // Apagar loading
      this.load(false);
    },
    /**
     * Metodo para hacer el filtro por el nombre de la empresa
     */
    async buscarEmpresa(query) {
      if (query.length >= 3) {
        this.listaEmpresas = this.empresas.filter((item) => {
          return item.nombre.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      } else {
        this.listaEmpresas = [];
      }
    },
    async buscarProductosTipos(query) {
      this.listaEmpresas = this.empresas.filter((item) => {
        return item.nombre.toLowerCase().indexOf(query.toLowerCase()) > -1;
      });

      this.buscador(this.filtro);
    },
    eliminar(item) {
      if (item && item.id) {
        this.productDelete = item
        this.showModalDelete = true;
      }
    },
    async cambiarEmpresa(id) {
      if (this.usuarioEmpresaContratista) {
        this.productos.total = null
        this.resetProductos();
      }
      // Permitir autoselección al cambiar de empresa
      this.disableAutoSelectLocations = false;
      this.setListaCampos([]);
      await this.loadLists(16);
      await this.setFilterBySelectedCompany({ company: id });
      await this.buscador(this.filtro);
      await this.getCamposPersonalizadosProd();
    },
    async cambiarProveedor() {
      this.establecerEmpresasFiltro([]);
      this.setEmpresaToFiltro(null);
      this.setListaCampos([]);
      await this.buscador(this.filtro);
    },
    async cargarUbicaciones(id) {
      this.load(true);
      if (id) {
        this._loadingFromCargarUbicaciones = true;
        await this.getAllCountriesByCompany(id);
        // Cargar ubicaciones con selección automática si el usuario tiene ubicaciones asignadas
        if (this.locations_user && this.locations_user.length > 0) {
          if (this.disableAutoSelectLocations) {
            await this.loadLocationsTree(id, this.filtro.country_id || null);
            this._loadingFromCargarUbicaciones = false;
          } else {
            const selectedLocationIds = await this.loadLocationsTreeWithMultipleAutoSelect(id, this.locations_user, this.filtro.country_id || null, this.my_company);
            if (selectedLocationIds && selectedLocationIds.length > 0) {
              this._skipInputHandler = true;
              this.val = selectedLocationIds;
              this.setFiltroUbicacion(selectedLocationIds);
              this.setFiltro({ ...this.filtro, ubicaciones: selectedLocationIds });
              this.$nextTick(() => {
                this._skipInputHandler = false;
              });
            }
            this._loadingFromCargarUbicaciones = false;
          }
        } else {
          await this.loadLocationsTree(id, this.filtro.country_id || null);
          this._loadingFromCargarUbicaciones = false;
        }
        this.mostrar = true;
        this.cambiaLoadingBasesAreas(true);
        if (validarPermisoComponente('listar-contratistas')) {
          await this.getContratista();
        }
      } else {
        this.mostrar = false;
      }
      this.load(false);
    },
    /**
     * Metodo que se inicia si el usuario es una empresa
     */
    async vistaEmpresa() {

      // Encender loading
      this.load(true);

      // Cargar acls
      this.acls = getAcls();

      // Organizar las columnas a mostrar en la tabla de productos
      this.columnas.push(
        {
          key: "nombre",
          label: "Nombre",
          sortable: true,
          thStyle: {
            "min-width": "150px !important",
          },
        },
        {
          key: "sinonimos",
          label: "Sinónimos",
          sortable: true,
          thStyle: {
            "min-width": "150px !important",
          },
        },
        {
          key: "fabricante.nombre",
          label: "Fabricante",
          sortable: true,
          thStyle: {
            "min-width": "150px !important",
            width: "150px !important",
          },
        },
        {
          key: "fecha",
          label: "Fecha Adjunto",
          sortable: true,
          thStyle: {
            "min-width": "130px !important",
            width: "130px !important",
          },
        },
        {
          key: "actions",
          label: "Opciones",
          tdClass: "text-nowrap",
          thStyle: {
            "min-width": "80px !important",
            width: "80px !important",
          },
        }
      );

      // Sí tiene permiso de visualizar FDS quitar acción
      if (validarPermisoComponente('visualizar-fds')) {
        const indexAction = this.columnas.findIndex(item => item.key == 'actions');
        this.columnas.splice(indexAction, 1)
      }

      // Limpiar los productos
      this.resetProductos();

      // Establecer la información de productos químicos
      this._skipEmpresaWatcher = true;
      this.setFiltroEmpresa(this.acls.empresa);
      this._skipEmpresaWatcher = false;

      this.VisualEmpresa.formatoEtiqueta = this.formatosEtiqueta[0].value;
      this.verProductos = true;

      // Ubicaciones
      await this.cargarUbicaciones(this.acls.empresa);

      // Cargar los productos de la empresa (con el filtro de ubicaciones aplicado)
      await this.getProductosEmpresa();

      // Cargar los campos personalizados de la empresa
      await this.getCamposPersonalizadosProd();

      // Apagar loading
      this.load(false);
    },
    async cargarFiltro() {
      this.listaEmpresas = [];
      await this.getEmpresaFiltro();
    },

    /**
    * Abre el drawer de IA.
    *
    * @param {string} action - Action to open the drawer. 'CREATE' or 'UPDATE'.
    * @param {number} productId - Product ID to update.
    */
    openAiDrawer(action, productId = null) {
        if (action === 'CREATE') {
          this.$refs.aiDrawerCreate.open();
          return;
        }

        this.$refs.aiDrawerUpdate.open(productId);
    },

    /**
    * Maneja la respuesta de la IA para actualizar el producto.
    *
    * @param {boolean} success - Success of the response.
    * @param {object} response - Response of the IA. [message, data]
    */
    onHandleUpdateTemporaryProductWithIA(success, response) {
        if (!success) return;
        this.$router.push(`/productos/${response.data.product_id}`)
    },

    async cargarFabricantes() {
      this.load(true);
      this.listaFabricantes = [];
      await this.listarFabricantesLista();
      this.load(false);
    },

    async buscarFabricante(query) {
      if (query.length >= 3) {
        this.listaFabricantes = this.fabricantes.filter((item) => {
          return item.nombre.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      } else {
        this.listaFabricantes = [];
      }
    },

    async filtroTipoProducto() {
      if (!this.tipoProductos.length) {
        await this.cargarTipoProducto();
      }
    },
    /**
     * Metodo que se inicia si el usuario es un administrador
     */
    async vistaAdmin() {
      this.columnas.push(
        {
          key: 'select-product',
          label: '',
          sortable: false,
          thStyle: {
            'min-width': '40px !important',
          },
          tdClass: "align-middle",
        },
        {
          key: 'nombre',
          label: 'Nombre',
          sortable: true,
          thStyle: {
            'min-width': '150px !important',
          },
          tdClass: "align-middle",
        },
        {
          key: 'sinonimos',
          label: 'Sinónimos',
          sortable: true,
          thStyle: {
            'min-width': '150px !important',
          },
          tdClass: "align-middle",
        },
        {
          key: 'modulo_creacion',
          label: 'Creado desde',
          sortable: true,
          thStyle: {
            'min-width': '80px !important',
          },
          tdClass: "align-middle",
        },
        {
          key: 'sgaData',
          label: 'SGA',
          sortable: true,
          thClass: this.usuarioEmpresaContratista ? 'd-none' : '',
          tdClass: this.usuarioEmpresaContratista ? 'd-none' : 'align-middle',
          thStyle: {
            'min-width': '70px !important',
            width: '70px !important',
          },
        },
        {
          key: 'nfpaData',
          label: 'NFPA',
          sortable: true,
          thClass: this.usuarioEmpresaContratista ? 'd-none' : '',
          tdClass: this.usuarioEmpresaContratista ? 'd-none' : 'align-middle',
          thStyle: {
            'min-width': '70px !important',
            width: '70px !important',
          },
        },
        {
          key: 'unData',
          label: 'UN',
          sortable: true,
          thClass: this.usuarioEmpresaContratista ? 'd-none' : '',
          tdClass: this.usuarioEmpresaContratista ? 'd-none' : 'align-middle',
          thStyle: {
            'min-width': '70px !important',
            width: '70px !important',
          },
        },
        {
          key: 'fabricante.nombre',
          label: 'Fabricante',
          sortable: true,
          thStyle: {
            'min-width': '130px !important',
            width: '130px !important',
          },
          tdClass: "align-middle",
        },
        {
          key: 'fecha',
          label: 'Fecha Adjunto',
          sortable: true,
          thStyle: {
            'min-width': '130px !important',
            width: '130px !important',
          },
          tdClass: "align-middle",
        },
        {
          key: 'actions',
          label: 'Opciones',
          tdClass: 'text-nowrap',
          thStyle: {
            'min-width': '110px !important',
            width: '110px !important',
          },
          tdClass: "align-middle",
        }
      );
      if (!this.usuarioEmpresaContratista || (this.usuarioEmpresaContratista && this.filtro.empresa)) {
        await this.getProductos().then(async () => {
          this.filtro.comments = this.filtro.comments.trim();
          this.searchTerm = structuredClone(this.filtro.comments);
          if (this.filtro.comments != '') {
            const actionsIndex = this.columnas.findIndex(col => col.key === 'actions');
            const commentsColumn = {
              key: 'comments',
              label: 'Comentarios',
              sortable: true,
              thStyle: {
                'min-width': '130px !important',
                width: '130px !important',
              },
            };
            // Insertar 'comments' antes de 'actions'
            this.columnas.splice(actionsIndex, 0, commentsColumn);
          } else {
            const commentsIndex = this.columnas.findIndex(col => col.key === 'comments');
            if (commentsIndex !== -1) {
              this.columnas.splice(commentsIndex, 1);
            }
          }

        });
      }
      else if (this.usuarioEmpresaContratista) {

        if (this.filtro.nombre && this.filtro.id_fabricante || this.filtro.empresa || this.filtro.empresa && this.filtro.contratista) await this.getProductos();
        else {

          if (!this.firstLoad && !this.removeFilterByBtnTrash) {
            Swal.fire({
              position: 'center',
              icon: 'info',
              title: 'Faltan datos para realizar la búsqueda',
              text: 'Debe ingresar el nombre del producto a buscar y seleccionar un fabricante.',
            });
          }
          return false;
        }
      }
      this.listaEmpresas = this.empresas;
      this.verProductos = true;
    },

    unClass(item) {
      if (validarRol('empresa') && validarPermisoComponente('ver-colores-estado-en-tabla-productos')) {
        if (item.producto_rpq.length && item.producto_rpq[0]['pago'] == 1) return 'table-success';
        if (item.adjuntos.length && item.adjuntos.every((adj) => adj.cumple_decreto == '162')) return 'table-orange';
        if (item.adjuntos.length && item.adjuntos.some((adj) => adj.cumple_decreto == '163')) return 'table-warning';
        if (!item.adjuntos.length) return 'table-danger';
      }
      if (!item || !(validarRol('superadmin') || validarRol('admin'))) return '';
      if (!item.sga || !item.u_n) return 'table-danger';
      if (item.bloqueo == 1) return 'table-success';
      if (item.bloqueo == 0) return 'table-warning';
    },

    async buscador(buscar, in_use) {
      if (this.loading) return;

      this.removeFilterByBtnTrash = false;

      if (this.editarProductos) {
        this.setFiltro(buscar);
        await this.vistaAdmin();
        return;
      }
      await this.vistaEmpresa();
    },
    async filtrarUbicaciones(ubicaciones) {
      if (this._skipInputHandler) return;
      if (!this.cargandoUbicaciones) {

        // Encender loading ubicaciones
        this.cargandoUbicaciones = true;

        // Si el usuario limpió manualmente las ubicaciones, desactivar autoselección futura
        if (!ubicaciones || (Array.isArray(ubicaciones) && ubicaciones.length === 0)) {
          this.disableAutoSelectLocations = true;
        }

        // Establecer ubicaciones
        this.setFiltroUbicacion(ubicaciones);
        this.setFiltro({ ...this.filtro, ubicaciones: ubicaciones });

        this.load(true);
        if (this.editarProductos) {
          await this.getProductos();
        } else {
          await this.getProductosEmpresa();
        }
        this.load(false);

        this.cargandoUbicaciones = false;
      }
    },
    async descargaAdjunto(adj, producto) {
      adj.producto = producto.nombre;
      await this.descargarAdjunto(adj);
      // window.open(process.env.VUE_APP_API_URL + "storage/files/" + adj.adjunto);
    },
    // reemplazado por loadLocationsTree vía composable
    ...mapActions("sysList", ["loadLists"]),
    ...mapActions('productos', [
      'getProductos',
      'setFilterBySelectedCompany',
      'getProductosEmpresa',
      'getEmpresaFiltro',
      'cargarTipoProducto',
      'getBasesFiltro',
      'getAreasFiltro',
      'getCamposPersonalizadosProd',
      'getProductoTarjeta',
      'setPagePagination',
      'getCamposPersonalizadosEmp',
      'getContratista',
      'setPerPagePagination',
      'desactivarProducto',
      'listarFabricantesLista',
      'obtenerFabricantesFiltro',
      'obtenerEmpresasFiltro',
      'obtenerMotivos',
      'bloquearProducto',
      'fetchProviders',
      'deleteProducts',
      'deleteProduct',
      'updateSelecteProducts',
      'validateAddProductCompany',
      'assingProductCompany',
      'getHistoryUpdateProducts'
    ]),
    ...mapActions("asignacionproductos", [
      "changeUseProductCompany",
    ]),
    ...mapMutations('dashboard', ['load']),
    ...mapMutations('pasoapaso', ['setModalVer', 'setComponents']),
    ...mapMutations("location", ["resetLocations"]),
    ...mapMutations('productos', [
      'resetProductos',
      'setFiltro',
      'setFiltroBases',
      'setFiltroAreas',
      'setPage',
      'setPermisosAdmin',
      'setPermisosEmpresa',
      'resetFiltro',
      'setFiltroEmpresa',
      'cambiaLoadingBasesAreas',
      'cambiaPermisoGuardar',
      'asignaRolProductos',
      'setFiltroUbicacion',
      'setEsEmpresaContratista',
      'setLimpiarEmpresas',
      'asignaRol',
      'setListaCampos',
      'setEmpresaToFiltro',
      'establecerEmpresasFiltro',
      'resetSelectedProducto',
      'setAddProductCompany',
      'setAvailableQuantity',
      'setUpFileExcelShow',
      'resetHistoryRegistersProducts'
    ]),
    ...mapMutations('asignacionproductos', [
      'setLoadingCancelProcess',
      'cargarInfoProducto'
    ]),
    ...mapMutations('assignPQTraceable', ['setActionToTraceablePQ', 'setDataTraceable']),
    ...mapActions("usabilityEvents", ["createUsabilityEvents"]),
    async asigProducto(item) {
      this.load(true);
      this.IdProducto = item.id;
      if (this.editarProductos) {
        await this.getInfoAsignacion(this.IdProducto);
        this.setModalAsignacionVer(true);
        await this.getEmpresasAsig(this.IdProducto);
        this.resetSelectedEmpresa();
      } else {
        this.cargarInfoProducto({ ...this.infoProducto, nombre: item.nombre });
        this.$nextTick(() => {
          this.setModalAsignacionVer(true);
        });
      }
      this.load(false);
    },
    async openModalAssingProduct() {
      const acls = getAcls();
      await this.validateAddProductCompany(acls.empresa);
      this.companyName = `${acls.info_empresa.nombre} - Cantidad disponible:${this.availableQuantity}`;
      this.setSelectedProduct(null);
      this.resetSelectedProducto();
      this.setModalSearchAndAssingProducts(true);
    },
    validarAsignacionProductoContratista(producto) {
      let id_producto;
      if (producto.temporal) {
        id_producto = producto.id_producto;
      } else {
        id_producto = producto.id;
      }
      return this.productos_contratistas.filter(
        (pc) => pc.id_producto === id_producto
      );
    },
    /**
    * Identifica si el producto tiene una relación con la empresa.
    *
    * @param {Object} product
    * @author Fernando Claros
    */
    isStatusUseByProduct(product) {
      return !!(product && product.producto_empresas && typeof product.producto_empresas === 'object');

    },
    /**
    * Obtiene el estado de uso del producto.
    *
    * @param {Object} product
    * @author Fernando Claros
    */
    getStatusUseByProduct(product) {
      if (this.isStatusUseByProduct(product) && 'in_use' in product.producto_empresas && product.producto_empresas.in_use) return true;
      return false;
    },
    validarEdicionProductoContratista(id_producto) {
      return this.productos_temporales.filter((pt) => pt.id === id_producto);
    },
    ...mapActions('asignacionproductos', [
      'getInfoAsignacion',
      'getEmpresasAsig',
      'getCamposPersonalizados'
    ]),
    ...mapActions('acls', [
      'validarPermiso'
    ]),
    ...mapActions('adjuntos', ['descargarAdjunto', 'getTipo']),
    ...mapMutations('productos_emp', ['limpiaBasesAreasEmpresa']),
    ...mapMutations('asignacionproductos', [
      'setModalAsignacionVer',
      'resetSelectedEmpresa',
      'setSelectedEmpresa',
      'setSelectedProduct',
      'setModalSearchAndAssingProducts',
      'setProductsToAssing'
    ]),
    ...mapActions('nuevocas', [
      'listarComponentes',
    ]),
    ...mapActions('assignPQTraceable', ['getTraceableByCompanyAndAssignId']),
    ...mapMutations('nuevocas', ['setFiltroBuscadorComponente']),
    async searchComponentRemote(val) {
      this.setFiltroBuscadorComponente({
        buscar: val,
        page: 1,
      })
      await this.listarComponentes();
    },
    getType(attachment) {

      if (this.isCluingTypeAttachment(attachment)) return attachment.tipo_adjunto.lista

      const typeMap = {
        154: 'FDS',
        155: 'MSDS',
        1055: 'CNP'
      };
      return typeMap[attachment.tipo];
    },

    getLanguage(attachment) {
      try {
        let languageName;
        if (attachment.language && attachment.language.name) {
            languageName = attachment.language.name;
        } else if (attachment.lista_idioma && attachment.lista_idioma.lista) {
            languageName = attachment.lista_idioma.lista;
        } else {
            languageName = 'No registra idioma';
        }
        return `, ${languageName}`;
      } catch (error) {
        return ', No registra idioma';
      }
    },

    getComments(item) {
      return item.producto_empresa && item.producto_empresa.length && item.producto_empresa[0].traceable_upgrades && item.producto_empresa[0].traceable_upgrades.length
        ? item.producto_empresa[0].traceable_upgrades[0].comments
        : '';
    },
    showComment(item) {
      let comment = this.getComments(item);
      const maxChars = 50;
      if (comment.length <= maxChars) return comment;

      const searchIndex = comment.toLowerCase().indexOf(this.searchTerm.toLowerCase());
      const start = Math.max(0, searchIndex - 25);
      const truncatedComment = comment.substring(start, start + maxChars);

      return `${start > 0 ? '...' : ''} ${truncatedComment} ${start + maxChars < comment.length ? '...' : ''}`;
    },
    async onHandleShowModalComments(item) {
      if (item.producto_empresa.length) {
        let assignId = item.producto_empresa[0]['id'];
        let product_id = item.producto_empresa[0]['id_producto'];
        let company_id = this.filtro.empresa;

        this.setActionToTraceablePQ({
          action: 'NOTA',
          data: null
        })
        this.setDataTraceable({
          assignId,
          company_id: this.filtro.empresa,
          product_id,
          product: {
            ...item,
            company: this.empresas_filtro.find(x => x.id == this.filtro.empresa)
          }
        });
        this.$bvModal.show('modalTraceablePQHistoryComponent')
        await this.getTraceableByCompanyAndAssignId({
          load: 'ALL',
          assignId,
          company_id: company_id,
          ...this.dataModalTraceable.table.data
        });
      }
    },
    async deleteSelectedProducts() {
      await this.deleteProducts(this.selectedProductIds);
      //this.selectedProductIds = [];
    },

    /**
     * Abre el drawer de IA.
     *
     * @param {string} action - Action to open the drawer. 'CREATE' or 'UPDATE'.
     * @param {number} productId - Product ID to update.
     */
    openAiDrawer(action, productId = null) {
      // Emitir evento para abrir el drawer de IA

      if (action === 'CREATE') {
        this.$refs.aiDrawerCreate.reset();
        this.$refs.aiDrawerCreate.showSidebar = true;
        return;
      }

      this.$refs.aiDrawerUpdate.reset();
      this.$refs.aiDrawerUpdate.showSidebar = true;
      this.$refs.aiDrawerUpdate.productId = productId;
    },

    /**
     * Maneja la respuesta de la IA para actualizar el producto.
     *
     * @param {boolean} success - Success of the response.
     * @param {object} response - Response of the IA. [message, data]
     */
    onHandleUpdateTemporaryProductWithIA(success, response) {
      if (!success) return;

      this.$router.push(`/productos/${response.data.product_id}`)
    },

  },

  computed: {
    ...mapState('assignPQTraceable', ['dataModalTraceable', 'traceable']),
    ...mapState('productos', [
      'productos',
      'productos_contratistas',
      'productos_temporales',
      'filtro',
      'empresas',
      'selectedProduct',
      'bases',
      'areas',
      'campos',
      'esAdmin',
      'esEmpresa',
      'loadingBasesAreas',
      'opcionGuardar',
      'contratistas',
      'rolProductos',
      'ubicaciones',
      'ubicEmpresa',
      'esEmpresaContratista',
      'esHse',
      'fabricantes',
      'esAdminTec',
      'tipoProductos',
      'formatosEtiqueta',
      'fabricantes_filtro',
      'empresas_filtro',
      'proveedores',
      'addProductCompany',
      'availableQuantity'
    ]),
    ...mapState('asignacionproductos', ['infoProducto', 'modalAsignacion', 'modalSearchAndAssingProducts']),
    ...mapGetters('productos', ['getParams', 'getEmpresasFil']),
    ...mapState('adjuntos', ['urlDescarga', 'tipos']),
    ...mapState('etiquetas', {
      pathAttachmentPdfProduct: 'dirEtiqueta',
      VisualEmpresa: 'VisualEmpresa'
    }),
    ...mapState('dashboard', ['loading']),
    ...mapState('autenticacion', ['usuarioEmpresaContratista', 'usuarioAdmin', "usuarioEmpresa", 'my_company', 'locations_user']),
    ...mapState('nuevocas', ['todosLoscomponentes']),
    ...mapState("sysList", ["lists"]),
    ...mapState("configurableVariables", ["allCountries"]),
    ...mapState("location", ["treeWithChildrens"]),
    useDates() {
      return (this.filtro.nombre || this.filtro.id_fabricante) ? true : false;
    },
    camposActivosFiltrados() {
      if (this.campos && this.campos.data) {
        return this.campos.data.filter(campo => campo.activo === 1);
      }
      return [];
    },
    getAvailableTypes() {
      return this.tipos.filter(x => (x.value !== 157));
    },
    getAttachmentComplianceList() {
      const noDocumentItem = { id: 'sd', lista: 'Sin documento', codigo: '000000' };
      return [...this.lists, noDocumentItem];
    },
    // Obtener los productos
    getProductsData() {
      return (typeof this.productos.data === 'object' && this.productos.data.length > 0) ? this.productos.data : []
    },
    filteredFields() {
      return this.columnas.filter(field => {
        if (field.key !== 'select-product') return field;
        else if (validarPermisoComponente('eliminar-multiples-productos-quimicos')) return field;
      });
    },
    // Indica si el producto es sin caracterización.
    isUncharacterizedProduct() {
      return (producto) => {
        return producto &&
          (!producto.producto_bloqueo || producto.bloqueo === null) &&
          (!producto.Sga || !producto.UN);
      };
    },
    // Devuelve las opciones de cumplimiento válidas según el tipo de adjunto seleccionado.
    filteredAttachmentComplianceList() {
      if (this.filtro.tipo === 154) {
        return this.getAttachmentComplianceList.filter(
          item =>
            item.id === 162 ||
            item.id === 163
        );
      }
      return this.getAttachmentComplianceList;
    },
    // Indica si se debe mostrar el select de cumplimiento de adjuntos.
    showAttachmentComplianceSelect() {
      return (
        this.filtro.empresa &&
        this.validarPermisoComponente('filtro-tipos-adjuntos') &&
        this.filtro.tipo !== 155
      );
    },
    // Indica si se debe mostrar el select de tipo de adjunto.
    showAttachmentTypeSelect() {
      const cumple = this.filtro.cumplimiento === 162 || this.filtro.cumplimiento === 'sd';
      return this.filtro.empresa && this.validarPermisoComponente('filtro-tipos-adjuntos') && !cumple;
    },
    // Devuelve los tipos de adjunto disponibles según el cumplimiento seleccionado.
    filteredAvailableTypes() {
      if (this.filtro.cumplimiento === 163) {
        return this.tipos.filter(x => x.value === 154 || x.value === 155);
      }
      return this.tipos.filter(x => x.value !== 157);
    },
    selectedCountryCode() {
      if (!this.filtro || !this.filtro.country_id) return null;
      const found = this.allCountries.find(c => c.country.id === this.filtro.country_id);
      if (found) {
          return found.country.code.toUpperCase();
      }
      return null;
    },
  },
  watch: {
    'filtro.statusEmp': function (val) {
      if (!val) return;
      this.setPage(1);
    },
    //  Sincroniza cumplimiento cuando cambia el tipo de adjunto.
    'filtro.tipo'(newVal) {
      if (newVal === 154 && this.filtro.cumplimiento === 'sd') {
        this.filtro.cumplimiento = '';
      }
      if (newVal === 155) {
        this.filtro.cumplimiento = '';
      }
    },
    // Sincroniza tipo de adjunto cuando cambia el cumplimiento.
    'filtro.cumplimiento'(newVal) {
      if (newVal === 162 || newVal === 'sd') {
        this.filtro.tipo = '';
      }
      if (newVal === 163 && this.filtro.tipo && ![154, 155].includes(this.filtro.tipo)) {
        this.filtro.tipo = '';
      }
    },
    'filtro.empresa'(newVal) {
      if (this._skipEmpresaWatcher) return;

      if (newVal) {
        this.country_id = null;
        this.val = null;
        this.setFiltroUbicacion([]);
        this.setFiltro({ ...this.filtro, ubicaciones: [] });

        this.loadCompanyGeo({ company_id: newVal, country_id: null });
      }
      if (!newVal) {
        this.filtro.country_id = null;
        this.val = null;
        this.setFiltroUbicacion([]);
        this.setFiltro({ ...this.filtro, ubicaciones: [] });
      }
    },
    'allCountries'(nextState) {
      if (nextState.length == 1) {
        this.filtro.country_id = nextState[0].country.id;
      }

      if (nextState.length == 0) {
        this.filtro.country_id = null;
      }
    },
    'filtro.country_id'(newVal) {
      if (this._loadingFromCargarUbicaciones) return;
      if (this.filtro.empresa) {
        // limpiar siempre ubicaciones al cambiar país
        this.val = null;
        this.setFiltroUbicacion([]);
        this.setFiltro({ ...this.filtro, ubicaciones: [] });

        // Cargar ubicaciones con selección automática si el usuario tiene ubicaciones asignadas
        if (this.locations_user && this.locations_user.length > 0) {
          if (this.disableAutoSelectLocations) {
            // El usuario modificó la selección manualmente — solo buscar, sin recargar árbol
            this.buscador(this.filtro);
          } else {
            const selectedLocationIds = this.loadLocationsTreeWithMultipleAutoSelect(this.filtro.empresa, this.locations_user, newVal || null, this.my_company);
            selectedLocationIds.then(ids => {
              if (ids && ids.length > 0) {
                this.val = ids;
                this.setFiltroUbicacion(ids);
                this.setFiltro({ ...this.filtro, ubicaciones: ids });
              }
              this.buscador(this.filtro);
            });
          }
        } else {
          this.buscador(this.filtro);
        }
      }
    }
  }

};
</script>

<style src="@riophae/vue-treeselect/dist/vue-treeselect.min.css"></style>

<style>
.height-table-pr {
  min-height: 300px;
}


.table-orange,
.table-orange>th,
.table-orange>td {
  background-color: #FFCC80;
}

.clickeable {
  cursor: pointer;
}

.el-input__inner {
  height: 32px;
}

.botonProduct {
  cursor: pointer;
  color: #20a8d8 !important;
}

.el-date-editor .el-range-separator {
  line-height: 25px;
  width: 10%;
}

.el-date-editor--monthrange.el-input,
.el-date-editor--monthrange.el-input__inner {
  width: 100%;
}

.el-select .el-input .el-select__caret {
  color: #333435;
  font-size: 16px;
  margin-top: 2px;
}

.width-select-options {
  width: 400px;
}

.buttonAdjunto {
  width: 100px;
}

.productos-faltantes-rpq {
  display: flex;
  justify-content: space-between;
}

@media only screen and (max-width: 675px) and (min-width: 575px) {
  .productos-faltantes-rpq {
    min-width: 100%;
  }
}

.el-select__tags {
  flex-wrap: wrap;
}

.el-select__input {
  flex-basis: 100%;
  min-width: 100%;
  margin-top: 4px;
}

.vue-treeselect__multi-value {
  max-height: 90px;
  overflow-y: auto !important;
}

.flag-img-select {
  height: 15px;
}

.flag-img-option {
  height: 20px;
}

.flag-img-tree {
  height: 15px;
}

.flag-prefix-container {
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 5px;
}
</style>
